// Permisos que entrega /api/auth/me. Solo deciden qué se muestra: la API los valida en cada operación.
export const PERMISO_CORRECCION_EXCEPCIONAL = 'cierres.correccion_excepcional';
export const tienePermiso = (me, permiso) => Boolean(me?.permisos?.includes(permiso));
